import Teleport from 'vue2-teleport';
export default {
  name: 'ModalOverlay',
  components: {
    Teleport
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    blur: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 999
    }
  }
};